import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { ITraveler } from "@hopper-b2b/types";
import { CheckboxGroup } from "@tenant/ui";
import { TravelerItemComponent } from "../TravelerItemComponent";
import styles from "../TravelerItemComponent/styles.module.scss";

export interface MultiSelectTravelerListComponentProps
  extends PlatformComponentProps {
  travelerList: ITraveler[];
  handleSelectTraveler: (travelerIds: string) => void;
  handleEdit: (travelerId: string) => void;
  handleDelete: (travelerId: string) => void;
  selectedTravelers: ITraveler[];
  disabled?: boolean;
}

export const MultiSelectTravelerList = ({
  travelerList,
  handleSelectTraveler,
  selectedTravelers = [],
  handleEdit,
  handleDelete,
  disabled,
}: MultiSelectTravelerListComponentProps) => {
  const [, cn] = useModuleBEM(styles, "TravelerList");

  if (travelerList.length === 0) {
    return null;
  }

  const options = travelerList.map((traveler) => ({
    value: traveler.id,
    labelComponent: ({ id, labelId }: { id: string; labelId?: string }) => (
      <TravelerItemComponent
        traveler={traveler}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        disabled={disabled}
        id={id}
        labelId={labelId}
      />
    ),
  }));

  const selectedTravelerIds = selectedTravelers.map((traveler) => traveler.id);

  return (
    <CheckboxGroup
      options={options}
      checkedOptions={selectedTravelerIds}
      onOptionClick={handleSelectTraveler}
      classNames={{
        container: cn("traveler-option-content"),
        itemContainer: cn("traveler-item", { disabled }),
      }}
      disabled={disabled}
    />
  );
};
